import { appState } from '../core/stateManager.js';
import { pStep, renderDashboard } from './proposal.js';
import { qStep } from './quickdoc.js';

function bindNavigationCommandEvents() {
    if (typeof window === 'undefined' || window.__AURADOC_NAV_COMMANDS_BOUND__) return;
    window.__AURADOC_NAV_COMMANDS_BOUND__ = true;

    window.addEventListener('auradoc:switchPipelineMode', (event) => {
        const mode = event.detail?.mode || event.detail || 'proposal';
        switchPipelineMode(mode);
    });

    window.addEventListener('auradoc:newProjectFromSourcing', (event) => {
        const detail = event.detail || {};
        const title = detail.title || '';
        const rfpText = detail.rfpText || '';
        const sourcingItem = detail.sourcingItem || null;
        appState.setState({ activeMode: 'proposal' });
        appState.newProject();

        if (title || rfpText || sourcingItem) {
            const state = appState.getState();
            appState.setState({
                projectData: {
                    ...state.projectData,
                    name: title || state.projectData.name,
                    rfp: rfpText || state.projectData.rfp,
                    context: sourcingItem
                        ? `나라장터 공고에서 시작한 제안서입니다. 발주기관: ${sourcingItem.org || '미제공'}`
                        : state.projectData.context,
                    sourcingItem
                }
            });
            const titleInput = document.getElementById('project-title-input');
            if (titleInput) titleInput.value = title;
            appState.saveCurrentProject();
            updateProjectDropdown();
        }

        switchPipelineMode('proposal');

        const currentState = appState.getState();
        const rfpTextArea = document.getElementById('p-rfp-text');
        const contextInput = document.getElementById('p-org-context');
        if (rfpTextArea) rfpTextArea.value = currentState.projectData.rfp || '';
        if (contextInput) contextInput.value = currentState.projectData.context || '';
        updateSourcingRfpNotice(sourcingItem);

        if (sourcingItem?.attachments?.length) {
            window.dispatchEvent(new CustomEvent('auradoc:extractSourcingAttachments', {
                detail: {
                    projectId: currentState.projectData.id,
                    attachments: sourcingItem.attachments
                }
            }));
        }
    });
}

function updateSourcingRfpNotice(sourcingItem) {
    const notice = document.getElementById('p-rfp-source-notice');
    const titleEl = document.getElementById('p-rfp-source-title');
    const detailEl = document.getElementById('p-rfp-source-detail');
    if (!notice || !titleEl || !detailEl) return;

    if (!sourcingItem) {
        notice.classList.add('hidden');
        return;
    }

    const attachmentCount = Array.isArray(sourcingItem.attachments) ? sourcingItem.attachments.length : 0;
    titleEl.innerText = '나라장터 공고 기본 정보가 추출되어 자동 입력되었습니다.';
    detailEl.innerText = attachmentCount
        ? `오른쪽 텍스트 영역에는 공고번호, 발주기관, 예산, 일정, 첨부 목록이 이미 들어가 있습니다. 첨부 파일 ${attachmentCount}개는 가능한 경우 자동으로 본문을 추가 추출하며, 필요한 RFP 파일은 왼쪽 업로드 영역에 직접 추가할 수 있습니다.`
        : '오른쪽 텍스트 영역에는 공고번호, 발주기관, 예산, 일정 등 공고 기본 정보가 이미 들어가 있습니다. 별도 RFP 파일이 있으면 왼쪽 업로드 영역에 추가하면 분석 입력값에 함께 반영됩니다.';
    notice.classList.remove('hidden');
}

bindNavigationCommandEvents();

export function switchPipelineMode(mode) {
    const pView = document.getElementById('pipeline-proposal');
    const qView = document.getElementById('pipeline-quickdoc');
    const sView = document.getElementById('pipeline-sourcing');
    const slider = document.getElementById('mode-slider');
    
    // UI IDs for GNB buttons (Unified model)
    const gnbButtons = {
        'proposal': document.getElementById('nav-unified'),
        'sourcing': document.getElementById('nav-sourcing')
    };

    const state = appState.getState();
    const targetMode = mode || state.activeMode || 'proposal';
    const navMode = targetMode === 'quickdoc' ? 'proposal' : targetMode;
    
    console.log(`[Nav] Switching to ${targetMode}`);

    if (state.activeMode !== targetMode) {
        appState.setState({ activeMode: targetMode });
    }

    // Update GNB Buttons and Slider visuals
    Object.keys(gnbButtons).forEach(key => {
        const btn = gnbButtons[key];
        if (!btn) return;
        if (key === navMode) {
            btn.classList.remove('text-slate-500');
            btn.classList.add('text-white');
        } else {
            btn.classList.remove('text-white');
            btn.classList.add('text-slate-500');
        }
    });

    // Move slider with pixel-perfect precision (2 buttons model)
    if (slider) {
        slider.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
        if (navMode === 'proposal') slider.style.left = '4px';
        else if (navMode === 'sourcing') slider.style.left = '122px';
    }

    // Toggle views
    const settingsView = document.getElementById('settings-view');
    if (settingsView) {
        settingsView.classList.add('hidden');
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
            mainContent.classList.remove('max-w-[1600px]');
            mainContent.classList.add('max-w-5xl');
            mainContent.style.maxWidth = '1024px';
        }
    }

    // Hide all main containers explicitly
    const containers = [pView, qView, sView, document.getElementById('dashboard-view'), document.getElementById('settings-view')];
    containers.forEach(v => {
        if (v) {
            v.classList.add('hidden');
        }
    });

    const isProjectMatching = state.currentProjectId && state.projectData;

    if (navMode === 'proposal') {
        const modeDesc = document.getElementById('mode-desc');
        if (modeDesc) modeDesc.innerText = "사용자 맞춤형 AI 스마트 문서 제작 워크플로우";
        if (isProjectMatching) {
            const currentState = appState.getState();
            if (currentState.projectData.mode === 'quickdoc' || targetMode === 'quickdoc') {
                qView.classList.remove('hidden');
                qStep(currentState.quickDocStep || 1);
            } else {
                pView.classList.remove('hidden');
                pStep(currentState.proposalStep || 1);
            }
        } else {
            showDashboard();
        }
    } else if (navMode === 'sourcing') {
        const modeDesc = document.getElementById('mode-desc');
        if (modeDesc) modeDesc.innerText = "나라장터 최신 공고를 검색하고 사업을 발굴합니다.";
        const tInput = document.getElementById('project-title-input');
        if (tInput) tInput.value = "나라장터 공고검색";
        showSourcing();
    }
}

export function showSourcing() {
    const dView = document.getElementById('dashboard-view');
    const pView = document.getElementById('pipeline-proposal');
    const qView = document.getElementById('pipeline-quickdoc');
    const sView = document.getElementById('pipeline-sourcing');
    const settingsView = document.getElementById('settings-view');

    [dView, pView, qView, settingsView].forEach(v => {
        if (v) {
            v.classList.add('hidden');
        }
    });

    if (sView) {
        sView.classList.remove('hidden');
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
            mainContent.classList.remove('max-w-5xl');
            mainContent.classList.add('max-w-[1600px]');
            mainContent.style.maxWidth = '1600px';
        }
        
        import('./sourcing.js')
            .then(m => m.initSourcingUI())
            .catch(err => {
                console.error("Dynamic import for sourcing.js failed, hard reloading:", err);
                window.location.reload(true);
            });
    }
}

export function showDashboard() {
    const state = appState.getState();
    const tInput = document.getElementById('project-title-input');
    if (tInput) {
        if (state.activeMode === 'proposal') {
            tInput.value = "스마트 문서 대시보드";
        } else {
            tInput.value = "대시보드";
        }
        tInput.readOnly = true;
        tInput.classList.remove('hover:bg-slate-50', 'cursor-pointer');
        tInput.classList.add('cursor-default');
    }
    
    document.getElementById('project-title-edit-icon')?.classList.add('hidden');
    document.getElementById('project-header')?.classList.remove('hidden');
    
    const dView = document.getElementById('dashboard-view');
    const pView = document.getElementById('pipeline-proposal');
    const qView = document.getElementById('pipeline-quickdoc');
    const sView = document.getElementById('pipeline-sourcing');
    const settingsView = document.getElementById('settings-view');

    [pView, qView, sView, settingsView].forEach(v => {
        if (v) {
            v.classList.add('hidden');
        }
    });

    if (dView) {
        dView.classList.remove('hidden');
        dView.style.border = '';
        dView.style.outline = 'none';
    }
    
    const s0 = document.getElementById('step-0');
    if (s0) {
        s0.classList.remove('step-hidden', 'hidden');
    }
    
    const pHeader = document.getElementById('project-header');
    if (pHeader) {
        pHeader.classList.remove('hidden');
    }

    renderDashboard();
    console.log("🏁 showDashboard completed");
    // Force Grid view as default
    let viewMode = 'grid';
    localStorage.setItem('dashboard_view_mode', 'grid');
    const gridBtn = document.getElementById('btn-view-grid');
    const listBtn = document.getElementById('btn-view-list');
    const gridView = document.getElementById('project-grid');
    const listView = document.getElementById('project-list');

    if (viewMode === 'grid') {
        gridView?.classList.remove('hidden');
        listView?.classList.add('hidden');
        gridBtn?.classList.add('bg-indigo-100', 'text-indigo-600');
        gridBtn?.classList.remove('bg-white', 'text-slate-400');
        listBtn?.classList.add('bg-white', 'text-slate-400');
        listBtn?.classList.remove('bg-indigo-100', 'text-indigo-600');
    } else {
        gridView?.classList.add('hidden');
        listView?.classList.remove('hidden');
        listBtn?.classList.add('bg-indigo-100', 'text-indigo-600');
        listBtn?.classList.remove('bg-white', 'text-slate-400');
        gridBtn?.classList.add('bg-white', 'text-slate-400');
        gridBtn?.classList.remove('bg-indigo-100', 'text-indigo-600');
    }

    // Title editing support
    const titleInput = document.getElementById('project-title-input');
    if (titleInput) {
        titleInput.addEventListener('change', (e) => {
            const newName = e.target.value.trim();
            if (newName && appState.getState().currentProjectId) {
                appState.setState({ projectData: { ...appState.getState().projectData, name: newName } });
                appState.saveCurrentProject();
                updateProjectDropdown();
            }
        });
        titleInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') titleInput.blur();
        });
    }
}

export function newProject() {
    const docSelector = document.getElementById('modal-doc-type-selector');
    if (docSelector) {
        docSelector.className = 'fixed inset-0 bg-slate-900/60 z-[300] flex justify-center items-center backdrop-blur-sm p-4';
    }
}

async function adminCreateUnifiedDoc(docType, mode, docName) {
    const docSelector = document.getElementById('modal-doc-type-selector');
    if (docSelector) {
        docSelector.className = 'modal-hidden fixed inset-0 bg-slate-900/60 z-[300] flex justify-center items-center backdrop-blur-sm p-4';
    }
    
    document.getElementById('step-0')?.classList.add('step-hidden');
    appState.newProject();
    
    const state = appState.getState();
    const docTypeNames = {
        'meeting': '회의록',
        'email': '이메일',
        'blog': '블로그',
        'experience': '체험학습'
    };
    const updatedProject = {
        ...state.projectData,
        name: `${docName || '새 스마트 문서'}`,
        mode: mode,
        documentType: docType,
        quickDocType: docTypeNames[docType] || '회의록'
    };
    
    appState.setState({
        projectData: updatedProject,
        proposalStep: 1,
        quickDocStep: 1
    });

    const saved = JSON.parse(localStorage.getItem('auradoc_projects') || '[]');
    const idx = saved.findIndex(p => p.id === state.currentProjectId);
    if (idx !== -1) {
        saved[idx] = {
            ...saved[idx],
            name: updatedProject.name,
            mode: mode,
            documentType: docType
        };
        localStorage.setItem('auradoc_projects', JSON.stringify(saved));
    }

    switchPipelineMode(mode);
}

window.adminCreateUnifiedDoc = adminCreateUnifiedDoc;

export function updateProjectDropdown() {
    const sel = document.getElementById('project-selector');
    if(!sel) return;
    
    sel.innerHTML = '<option value="">📂 빠른 프로젝트 이동</option>';
    const state = appState.getState();
    
    Object.keys(state.projects || {}).forEach(id => {
        sel.innerHTML += `<option value="${id}">${state.projects[id].name}</option>`;
    });
    
    if(state.currentProjectId && state.projects[state.currentProjectId]) {
        sel.value = state.currentProjectId;
    }
}

export function handleProjectSelect(event) {
    const id = event.target.value;
    if (!id) return;
    
    // Load the project - stateManager will handle mode switching if needed
    if (appState.loadProject(id)) {
        const state = appState.getState();
        // If the project mode is different from current UI, switchPipelineMode was already triggered by loadProject
        if (state.activeMode === 'quickdoc') {
            qStep(state.quickDocStep || 1);
        } else {
            pStep(state.proposalStep || 1);
        }
    }
}

export function initNavigation() {
    document.getElementById('nav-unified')?.addEventListener('click', () => switchPipelineMode('proposal'));
    document.getElementById('nav-sourcing')?.addEventListener('click', () => switchPipelineMode('sourcing'));
    document.getElementById('btn-logo-dashboard')?.addEventListener('click', showDashboard);

    document.getElementById('project-selector')?.addEventListener('change', handleProjectSelect);
    
    document.getElementById('btn-view-grid')?.addEventListener('click', () => {
        localStorage.setItem('dashboard_view_mode', 'grid');
        showDashboard();
    });
    document.getElementById('btn-view-list')?.addEventListener('click', () => {
        localStorage.setItem('dashboard_view_mode', 'list');
        showDashboard();
    });
    
    document.getElementById('btn-open-settings')?.addEventListener('click', () => window.location.href = 'admin.html?mode=settings');
    document.getElementById('btn-open-admin')?.addEventListener('click', () => window.location.href = 'admin.html?mode=admin');
    
    // Listen for state changes to update the dropdown
    appState.subscribe((state) => {
        const sel = document.getElementById('project-selector');
        if (sel && sel.value !== state.currentProjectId && state.currentProjectId) {
            sel.value = state.currentProjectId;
        }
    });

    window.adminCreateUnifiedDocTrigger = newProject;
    window.showDashboardTrigger = showDashboard;
}
